import { useApi } from 'hooks';

export const getPdfTotal = async (
  Api: ReturnType<typeof useApi>,
  siteId: string,
): Promise<number | null> => {
  try {
    const response = await Api.post('v1/remediation-orders/files-count', {
      siteId,
    });

    return response?.data?.pdfFilesCount;
  } catch (error) {
    console.error(error);
    return null;
  }
};
